import { AuthService } from '../services/authService';
import { StoreCustomerService } from '../services/storeCustomerService';
import { createApiStore } from './apiStore';

const authService = new AuthService();

const fetchData = async (data?: Object): Promise<Object> => {
  const token = data as string;
  await authService.ssoLogout(token);
  await new StoreCustomerService().logout();
  return true;
};

export const useSsoLogoutStore = createApiStore(fetchData);
